import  Swal  from 'sweetalert2';
import { Subscription } from 'rxjs/Rx';
import { Component, OnInit, OnChanges, ViewChild, ElementRef, OnDestroy, Input} from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Logger } from 'angular2-logger/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { PusherService } from '../../../shared/pusher.service';

import { SocketioService } from '../../socketio.service';
import { SharedService } from '../../../shared/shared.service';
import { DashboardService } from '../../dashboard.service';

import { Ng4FilesService, Ng4FilesConfig, Ng4FilesStatus, Ng4FilesSelected } from 'angular4-files-upload';
import { Http } from '@angular/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval } from 'rxjs/observable/interval';
import { startWith } from 'rxjs/operators';
import { HtmlParser } from '@angular/compiler';
import { UserService } from '../../../admin/user/user.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { DatePipe } from '@angular/common';


declare var jquery: any; 
declare var $: any;

@Component({
  selector: 'app-inforoom',
  templateUrl: './inforoom.component.html',
  styleUrls: ['./inforoom.component.scss'],
  providers: [PusherService, UserService]
})

export class InforoomComponent implements OnInit, OnChanges {
  public form: FormGroup;
  public room_id: string;
  public selectedFiles;
  public msg: string = '';
  public openPopup: Function;
  public block_room: any;
  public btn_control: boolean;
  public list_type: string;
  public title: string;
  public role_id: any;
  public user: any;
  public user_id: any;
  public holding_by: any;
  public class_control: any;
  public dateSelected: string;
  public diffHrs: any;
  public diffMins: any;
  public seconds: any;

  public pivote: string = '';  

  public matriz_aux = [];
  public matriz_global = [];
  public k:any = 0;

  public variable_nueva:any ;
  public id_category: any;
  public matriz_final:any ;

  public title_toModal: string;
  public body_toModal: string;
  public active_agents: any;
  public info_rooms: any;
  public comentarios: any;
  public plataform : any;
  public senderIdBot : any;
  public created_at : any;
  public tiempoEspera : any;
  public created_at_messages : any;
  public room_status_id : any;
  public fecha_fin : any;
  public session_id : any;
  public id_ticket : any;
  public time_zone : any;
  public time_zone_user : any;
  public time_zone_sistem: any;
  public diffMs: any


  public num:number = 1;

  public dDay = new Date('2021-10-05 10:41:06');
  milliSecondsInASecond = 1000;
  hoursInADay = 24;
  minutesInAnHour = 60;
  SecondsInAMinute  = 60;

  public timeDifference;
  public secondsToDday;
  public minutesToDday;
  public hoursToDday;
  public daysToDday;

  public banderaId : any;

  private subscription: Subscription;
  
  files: any[] = [];

  @Input() valueRoomID: any;

  public myDate : any = new Date();
  
  constructor( 
    private fb: FormBuilder,
    public _socketioService: SocketioService, 
    private _sharedService: SharedService,
    public toastr: ToastsManager,
    private userService : UserService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private _dashboardService: DashboardService, 
    private logger: Logger
  ) {
    this.btn_control = true;
    this.holding_by = null; 
    this.block_room = this._sharedService.activateBlockSupervisor().isAdmin;
    this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd H:mm:s');

    let data = { 
      auth_token: this._sharedService.getCookie("auth_token")
    };

    this._sharedService.getCurrent(data).subscribe(
      data => {
        //console.log('Esta es la data que retorna del profile a ver que sale : ', data);
        if (data.status) { 
          this.user = data.data;
          this.user_id = this.user.id;
          this.role_id = this.user.role_id;
          this.time_zone = data.data.time_zone;

        } else {
          this.logger.log(data.message); // Que no tengo permisos. 
        }
      },
      error => {
        //this.spinner.hide();
        this.logger.log(error);

      }
    );
  }

  

  ngOnInit() {
  }

  ngOnChanges() {
    this.minutesToDday = '';
    this.secondsToDday = '';
    this.hoursToDday   = '';
    this.informacionUser();
    this.getComentarios();
    this.myDate = new Date();
  }

  public roundDown(num){
      var full = num.toString();
      var reg = /([\d]+)/i;
      var res = reg.exec(full);
      return res[1];
  }

  public getComentarios() {
    let data;
    data = {
      auth_token: this._sharedService.getCookie("auth_token"),
      room_id: this.valueRoomID
    }

    this.userService.getInfoComments(data).subscribe(
      data => {
        if (data.data.data.length > 0) {
          this.comentarios  = data.data.data;
        } else {
          this.comentarios = [];
        }
      }, () => {
        this.title_toModal = "Advertencia";
        this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
      });
  }

  public informacionUser() {
    let data;
    data = {
      auth_token: this._sharedService.getCookie("auth_token"),
      room_id: this.valueRoomID
    }

    this.userService.getInfoRooms(data).subscribe(
      data => {
        for (let i in data.data.dataInfo) {
          console.log(data.data.dataInfo[i].created_at);
          this.plataform   = data.data.dataInfo[i].plataforma;
          this.senderIdBot = data.data.dataInfo[i].sender_id_bot;
          this.created_at = data.data.dataInfo[i].created_at;
          this.created_at_messages = data.data.dataInfo[i].created_at_messages;
          this.room_status_id = data.data.dataInfo[i].room_status_id;
          this.fecha_fin = data.data.dataInfo[i].fecha_fin;
          this.session_id = data.data.dataInfo[i].session_id;
          this.id_ticket = data.data.dataInfo[i].id_ticket;
          this.time_zone = data.data.dataInfo[i].time_zone;
          this.time_zone_sistem = data.data.dataInfo[i].time_zone_sistem;

        }

        if(this.time_zone_user!==this.time_zone){
        this.created_at= this._sharedService.convertirZonaHoraria(this.created_at,this.time_zone_user, this.time_zone_sistem);
        
        }

        let endDate : any = new Date(this.created_at);

        this.myDate = new Date();


        if(this.room_status_id != '1' && this.room_status_id != '2' && this.room_status_id != '3'){
          this.myDate = this.fecha_fin;
        }
        
        //console.log('endDate-->', this.created_at);
        //console.log('myDate-->', this.myDate);
        let operation = this._sharedService.compararZonasHorarias(this.time_zone_user,this.time_zone_sistem);

        let purchaseDate : any = new Date(this.myDate);
        
        if (operation === 'es mayor que') {
          this.diffMs = endDate - purchaseDate;
          //console.log('mayor');
        } else {
          this.diffMs = purchaseDate - endDate;
          //console.log('menor');
        }
        
        
         // milliseconds
        //let diffDays = this.roundDown(this.diffMs / 86400000); // days
        let diffHrs : any = this.roundDown((this.diffMs % 86400000) / 3600000); // hours
        let diffMins : any = this.roundDown(((this.diffMs % 86400000) % 3600000) / 60000); // minutes
        let seconds : any = this.roundDown((((this.diffMs % 86400000) % 3600000) % 60000) / 1000 ); // seconds
    
        if(diffHrs < 0) {
          diffHrs = 0;
        }

        if(diffMins < 0) {
          diffMins = 0;
        }

        if(seconds < 0) {
          seconds = 0;
        }
        
        this.myDate = new Date();
        

        this.created_at_messages= this._sharedService.convertirZonaHoraria(this.created_at_messages, this.time_zone, this.time_zone_sistem);

        let horaMensaje : any = new Date(this.created_at_messages);
        
        
        let purchaseDate2 : any = new Date(this.created_at);

        let diffMs2 = (purchaseDate2 - horaMensaje); // milliseconds
        let diffDays2 : any = this.roundDown(diffMs2 / 86400000); // days
        let diffHrs2 : any = this.roundDown((diffMs2 % 86400000) / 3600000); // hours
        let diffMins2 : any = this.roundDown(((diffMs2 % 86400000) % 3600000) / 60000); // minutes
        let seconds2 : any = this.roundDown((((diffMs2 % 86400000) % 3600000) % 60000) / 1000 );

        if(diffDays2 > 0) {
              this.tiempoEspera = diffDays2 + ' días';
        }else if(diffHrs > 0){
              this.tiempoEspera = diffHrs2 + ' hrs';
        } else if(diffMins < 60) {
              this.tiempoEspera = diffMins2 + " min";
        }



        var date = new Date('2020-01-01 ' + diffHrs + ': ' + diffMins + ': ' + seconds);
    
        //var date = new Date().getDay() - new Date("2021-10-05T10:41:06.753Z").getDay();
    
        // Función para rellenar con ceros
        var padLeft = n => "00".substring(0, "00".length - n.length) + n;
    
        // Asignar el intervalo a una variable para poder eliminar el intervale cuando llegue al limite
        var interval = setInterval(() => {
    
          // Asignar el valor de minutos
          this.minutesToDday = padLeft(date.getMinutes() + "");
          // Asignqr el valor de segundos
          this.secondsToDday = padLeft(date.getSeconds() + "");
    
          this.hoursToDday = padLeft(date.getHours() + "");
          
          if(this.room_status_id != '1' && this.room_status_id != '2' && this.room_status_id != '3'){
            clearInterval(interval); 
          }
          // Sumarle a la fecha actual 1000 milisegundos
          date = new Date(date.getTime() + 1000);
          /* console.log("TiempoRelojito: ",date); */
            
          // Si llega a 2:45, eliminar el intervalo
          
          if(this.banderaId && this.banderaId != this.valueRoomID) {
            clearInterval(interval); 
        }

          this.banderaId = this.valueRoomID;

          
        }, 1000);
        

        if (data.data.data.length > 0) {
          this.info_rooms  = data.data.data;
          this.title_toModal = "Información de usuario para la sala con el ID #";
          this.body_toModal = "Si hay información";
        } else {
          this.info_rooms = [];
          this.title_toModal = "Advertencia";
          this.body_toModal = "No hay información de usuario disponible para la sala con el ID #";
        }
      }, () => {
        this.title_toModal = "Advertencia";
        this.body_toModal = "Ups!. Ha ocurrido un error con el servidor inténtalo de nuevo.";
      });
      
  }


  sendEnter(event) {
    this.sendComments();
} 

  onKeydown(event) {
    event.preventDefault();
  }

  sendComments() {
    this.spinner.show();
    let data = {
      auth_token: this._sharedService.getCookie('auth_token'),
      room: this.valueRoomID,
      message: this.msg,
      user_id: this.user_id
    };

    this._dashboardService.sendComments(data).subscribe( // send to the server
      data => {
        this.spinner.hide();
        this.getComentarios();
      },
      error => {

        this.spinner.hide();
        this.logger.log(error);

      }
    );

    this.msg = '';
  }
  
  deleteComment (id) {
    this.spinner.show();
    let data = {
      auth_token: this._sharedService.getCookie('auth_token'),
      id: id
    };

    this._dashboardService.deleteComments(data).subscribe(
      data => {
        this.spinner.hide();
        this.getComentarios();
      },
      error => {

        this.spinner.hide();
        this.logger.log(error);

      }
    );
  }

  onDateChange(){
    this.msg += " " + this.dateSelected
  }



  




}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/chat/inforoom/inforoom.component.ts